import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const UPDATE_SMTP_CONFIGURATION_MUTATION = gql`
  mutation UpdateSmtpConfiguration($input: SmtpConfigurationInput!) {
    updateSmtpConfiguration(input: $input) {
      smtpConfiguration {
        id
        address
        port
        domain
        userName
        authentication
        encryption
        senderEmail
        senderName
        createdAt
        updatedAt
      }
    }
  }
`;

export interface SmtpConfigurationInput {
  address: string;
  port: number;
  domain?: string;
  userName: string;
  password?: string;
  authentication: string;
  encryption: string;
  senderEmail: string;
  senderName?: string;
}

interface UpdateSmtpConfigurationResponse {
  updateSmtpConfiguration: {
    smtpConfiguration: {
      id: string;
      address: string;
      port: number;
      domain: string | null;
      userName: string;
      authentication: string;
      encryption: string;
      senderEmail: string;
      senderName: string | null;
      createdAt: string;
      updatedAt: string;
    };
  };
}

interface UseUpdateSmtpConfigurationOptions {
  onCompleted?: () => void;
  onError?: (error: any) => void;
}

export function useUpdateSmtpConfiguration(options?: UseUpdateSmtpConfigurationOptions) {
  const [updateSmtpConfigurationMutation, { loading }] = useMutation<UpdateSmtpConfigurationResponse>(UPDATE_SMTP_CONFIGURATION_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao salvar configuração SMTP';
        toast.error(message);
      }
    },
  });

  const updateSmtpConfiguration = (input: SmtpConfigurationInput) => {
    return updateSmtpConfigurationMutation({
      variables: { input },
    });
  };

  return { updateSmtpConfiguration, loading };
}
